import {Dialog} from '@primer/react'

import styles from './ImagePreviewDialog.module.css'

export interface ImagePreviewDialogProps {
  /** Fully-qualified image source (e.g. a `data:` URL) to preview. */
  src: string
  /** Human-readable dialog title. */
  title: string
  /** Accessible text for the image. Leave empty when the title is only a generic filename. */
  alt?: string
  /** Called when the dialog requests to close. */
  onClose: () => void
}

/** A modal that shows a single image at a larger, contained size. */
export function ImagePreviewDialog({src, title, alt = '', onClose}: ImagePreviewDialogProps) {
  return (
    <Dialog onClose={onClose} title={title} width="xlarge">
      <div className={styles.imageContainer}>
        <img src={src} alt={alt} className={styles.image} data-testid="image-preview-dialog-image" />
      </div>
    </Dialog>
  )
}
